import { createRoot } from 'react-dom/client';
import './design/styles';
import { chargerConfig } from './core/config';
import { App } from './core/App';
import { restaurerZoom } from './core/zoom';

// Zoom de l'affichage gardé sur l'appareil, avant tout affichage (pas de saut à l'arrivée des préférences).
restaurerZoom();
const racine = document.getElementById('racine')!;
chargerConfig().then(
  (config) => createRoot(racine).render(<App config={config} />),
  // Avant le chargement de la langue : message neutre, sans texte métier
  () => {
    racine.textContent = 'AGORA – configuration indisponible / configuration unavailable.';
  },
);
